import { createContext, useContext } from 'react';

/**
 * Shares the auth-page MascotDuo ref between AuthLayout (which owns the mount)
 * and the form pages rendered inside the <Outlet/> (which trigger reactions).
 *
 * Usage:
 *   const mascot = useMascot();
 *   mascot.current?.celebrate();
 *
 * Safe to call when null — pages outside AuthLayout will get an empty ref.
 */
export const MascotContext = createContext({ current: null });

export function useMascot() {
  return useContext(MascotContext);
}
